import {ref, nextTick} from "vue"

const messagesBox = ref<HTMLElement | null>(null)
const messageArea = ref<any>(null)

const scrollBottom = () => {
  nextTick(() => {
    if (messagesBox.value) {
      console.log("scroll bottom", messagesBox.value.scrollTop, messagesBox.value.scrollHeight)
      messagesBox.value.scrollTop = messagesBox.value.scrollHeight;
    }
  })
}

export {
  messageArea,
  messagesBox,
  scrollBottom,
};